import { addDays, daysBetween } from './dates';

/**
 * Datas flexíveis ± 3 dias (WP-03). Desloca ida e volta juntas (mesma duração de viagem) e compara com a data
 * escolhida. Nunca troca a data da rota: só mostra.
 */
export const FLEX_SPAN_DAYS = 3;
/** Comparação refeita no máximo uma vez por semana por rota (custa uma busca por data). */
export const FLEX_EVERY_DAYS = 7;
/** Diferença mínima para dizer que outra data compensa. */
export const FLEX_MIN_SAVING_PCT = 3;

export interface FlexDate {
  offset: number;
  outboundDate: string;
  returnDate: string | null;
}

/** Datas vizinhas válidas: a ida tem de ser a partir de amanhã. Ordem: mais perto da data escolhida primeiro. */
export function flexDates(
  outbound: string,
  ret: string | null,
  today: string,
  span = FLEX_SPAN_DAYS,
): FlexDate[] {
  const out: FlexDate[] = [];
  for (let k = 1; k <= span; k++) {
    for (const offset of [-k, k]) {
      const o = addDays(outbound, offset);
      if (daysBetween(today, o) < 1) continue;
      out.push({ offset, outboundDate: o, returnDate: ret ? addDays(ret, offset) : null });
    }
  }
  return out;
}

export interface FlexQuote extends FlexDate {
  price: number;
}

export interface FlexOption extends FlexQuote {
  /** Diferença % para o preço da data escolhida (negativa = mais barato). */
  deltaPct: number;
}

/** Ordena por data e marca a diferença; devolve também a melhor opção quando ela economiza de verdade. */
export function compareFlex(basePrice: number, quotes: readonly FlexQuote[]) {
  const options: FlexOption[] = [...quotes]
    .sort((a, b) => a.offset - b.offset)
    .map((q) => ({ ...q, deltaPct: Math.round(((q.price - basePrice) / basePrice) * 100) }));
  const cheapest = options.reduce<FlexOption | null>((m, o) => (!m || o.price < m.price ? o : m), null);
  const best = cheapest && cheapest.deltaPct <= -FLEX_MIN_SAVING_PCT ? cheapest : null;
  return { options, best };
}

/** "Saindo 2 dias antes", "Saindo 1 dia depois". */
export function flexLabel(offset: number): string {
  const n = Math.abs(offset);
  return `Saindo ${n} ${n === 1 ? 'dia' : 'dias'} ${offset < 0 ? 'antes' : 'depois'}`;
}

/** A rota pede nova comparação? */
export function flexDue(lastFlexDay: string | null, today: string): boolean {
  return !lastFlexDay || daysBetween(lastFlexDay, today) >= FLEX_EVERY_DAYS;
}
